module.exports = __webpack_public_path__ + "images/xl_sichuan.jpg?09d6fb036fc8aabc635259400df73790";


//////////////////
// WEBPACK FOOTER
// ./src/images/xl_sichuan.jpg
// module id = 250
// module chunks = 1